import { defineComponent as _defineComponent } from 'vue'
import { FitHalfScreenDialogV2, FitIcon } from '@tencent/wphk-ui';
import { i18n } from '@/i18n';
import { ref } from 'vue';
import { language } from '@tencent/ppd-base-libs';

// 暴露方法

export default /*#__PURE__*/_defineComponent({
  __name: 'ekyc-bind-dialog',
  props: {
    options: null,
    optionsTitle: null
  },
  setup(__props: any, { expose }) {

expose({ onShowDialog });



// ekyc 弹窗
const ekycDialog = ref<InstanceType<typeof FitHalfScreenDialogV2> | null>(null);

// 打开弹窗
function onShowDialog() {
  ekycDialog.value?.showDialog();
}

// 关闭弹窗
function onHideDialog() {
  ekycDialog.value?.hideDialog();
}

function onClick(info) {
  if (typeof info?.onClick === 'function') {
    info.onClick();
  }
}

return { __sfc: true,ekycDialog, onShowDialog, onHideDialog, onClick, FitHalfScreenDialogV2, FitIcon, i18n, language }
}

})